import { render, staticRenderFns } from "./AnswerMachine.vue?vue&type=template&id=35dfbbb2"
import script from "./AnswerMachine.vue?vue&type=script&lang=js"
export * from "./AnswerMachine.vue?vue&type=script&lang=js"
import style0 from "./AnswerMachine.vue?vue&type=style&index=0&id=35dfbbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports